<section class="actions">
  <button *ngIf="!isLoading" mat-icon-button color="primary" [disabled]="disabling" (click)="onSubmit()">
    <mat-icon aria-label="Validate">check</mat-icon>
  </button>
  <button *ngIf="!isLoading" type="button" mat-icon-button (click)="onCancel()">
    <mat-icon aria-label="Cancel">clear</mat-icon>
  </button>
</section>